import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BackResourceService {

  private readonly HTTP = 'http://';
  private readonly HTTPS = 'https://';
  private readonly SLASH = '/';

  private baseUrlBack = environment.baseUrlBack;

  constructor() {
    if(this.baseUrlBack.endsWith(this.SLASH)){
      this.baseUrlBack = this.baseUrlBack.slice(0, -1);
    }
  }

  public getUrl(resource: string): string {
    if (resource.startsWith(this.HTTP) || resource.startsWith(this.HTTPS)) {
      return resource;
    }

    const separator = resource.startsWith(this.SLASH) ? '' : this.SLASH;
    return this.baseUrlBack + separator + resource;
  }
}
